import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { NgModule } from '@angular/core';

import { metaReducers } from './app-context.meta-reducers';
import { appContextFeature, initialState } from './app-context.feature';
import { AppContextEffects } from './app-context.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(appContextFeature.name, appContextFeature.reducer, {
      initialState, metaReducers,
    }),
    EffectsModule.forFeature([ AppContextEffects ]),
  ],
})
export class AppContextStateModule {}
